// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_2ecfFtYF","dadosContainer":"_1Z9vC6-0","content":"_1wik3_bR","title":"_38kIKKqr","error":"_3JV3oxeB","submitButton":"mf8MDcoc"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/pages/UserPasswordPage/UserPasswordPage.styl
// module id = 555
// module chunks = 0